// Time constants — milliseconds
export const MS_PER_MINUTE = 60_000;
export const MS_PER_HOUR = 3_600_000;
export const MS_PER_DAY = 86_400_000;
export const MS_PER_WEEK = 7 * MS_PER_DAY;

// Social presence: how recently a user must have been active to show as "online"
export const ONLINE_THRESHOLD_MS = 5 * MS_PER_MINUTE;
